






import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const ReportStore = namespace("Report");

@Component
export default class PageBanner extends Vue {
  public banners: Array<string> = [
    "https://www.kodeksprzejrzystosci.pl/assets/kodeksprzejrzystosci/banner-1.jpg",
    "https://www.kodeksprzejrzystosci.pl/assets/kodeksprzejrzystosci/banner-2.jpg",
    "https://www.kodeksprzejrzystosci.pl/assets/kodeksprzejrzystosci/banner-3.jpg"
  ];

  get bannerUrl(): string {
    return this.banners[2];
  }

  @ReportStore.State
  public reportYear!: number;
}
